import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useMemo, useRef } from 'react';
import uuid from 'uuid/v4';
import { AIEventsInstrumentationContext } from '../context';
import { AISessionState, EventDispatcherSources } from '../events';
export var defaultConfigValues = {
  isAIFeature: 1,
  actionSubjectId: 'client',
  eventDispatcherSource: EventDispatcherSources.JSLib,
  skipAISessionValidation: false,
  useDefaultGASv3EventSchema: false
};
var validateAIEventsConfig = function validateAIEventsConfig(config) {
  if (!config.aiFeatureName.match(/^[a-z][A-Za-z]*$/)) {
    // eslint-disable-next-line no-console
    console.error('[@atlassian/ai-analytics]: please set aiFeatureName in camelCase');
  }
};
export var AIEventsInstrumentationProvider = function AIEventsInstrumentationProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  var singleInstrumentationIDRef = useRef(undefined);
  var aiSessionStateRef = useRef(AISessionState.unset);
  var setAISessionState = useCallback(function (nextState) {
    aiSessionStateRef.current = nextState;
  }, []);
  var getAISessionState = useCallback(function () {
    return aiSessionStateRef.current;
  }, []);
  var refreshSingleInstrumentationID = useCallback(function (customSingleInstrumentationID) {
    var _ref2;
    // priority for setting singleInstrumentationID override rule
    // 1. from consumer event attribute
    // 2. from consumer configuration
    // 3. default behaviour generates through uuid lib
    singleInstrumentationIDRef.current = (_ref2 = customSingleInstrumentationID !== null && customSingleInstrumentationID !== void 0 ? customSingleInstrumentationID : config.singleInstrumentationID) !== null && _ref2 !== void 0 ? _ref2 : uuid();
  }, [config.singleInstrumentationID]);
  var getSingleInstrumentationID = useCallback(function () {
    // this handles a race condition when we have a new singleInstrumentationID from the user config
    // but Provider knows only about the initial singleInstrumentationID. In this case we need to update
    // singleInstrumentationID at first step and then return a new one.
    if (config.singleInstrumentationID && config.singleInstrumentationID !== singleInstrumentationIDRef.current) {
      refreshSingleInstrumentationID();
    }
    return singleInstrumentationIDRef.current;
  }, [refreshSingleInstrumentationID, config.singleInstrumentationID]);
  var contextValue = useMemo(function () {
    validateAIEventsConfig(config);
    return {
      config: _objectSpread(_objectSpread(_objectSpread({}, defaultConfigValues), config), {}, {
        product: config.product.toLowerCase()
      }),
      refreshSingleInstrumentationID: refreshSingleInstrumentationID,
      getSingleInstrumentationID: getSingleInstrumentationID,
      setAISessionState: setAISessionState,
      getAISessionState: getAISessionState
    };
  }, [config, refreshSingleInstrumentationID, getSingleInstrumentationID, setAISessionState, getAISessionState]);
  return /*#__PURE__*/React.createElement(AIEventsInstrumentationContext.Provider, {
    value: contextValue
  }, children);
};